import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import "./styles/global.css";

const DashboardBase = ({ 
  children, 
  title = "Dashboard", 
  userRole = "Admin",
  userName = "Usuario",
  navigationItems = [],
  activeNav = "dashboard"
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const defaultNavItems = [
    { id: "dashboard", label: "Dashboard", icon: "📊", path: "/" },
    { id: "empresas", label: "Empresas", icon: "🏢", path: "/empresas" },
    { id: "usuarios", label: "Usuarios", icon: "👥", path: "/usuarios" },
    { id: "empleados", label: "Empleados", icon: "👤", path: "/empleados" },
    { id: "evaluaciones", label: "Evaluaciones", icon: "📝", path: "/evaluaciones" },
    { id: "informes", label: "Informes", icon: "📋", path: "/informes" },
    { id: "reportes", label: "Reportes", icon: "📈", path: "/reportes" },
    { id: "configuracion", label: "Configuración", icon: "⚙️", path: "/configuracion" }
  ];

  const navItems = navigationItems.length > 0 ? navigationItems : defaultNavItems;

  const handleNavClick = (item) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <div className={`sidebar ${!sidebarOpen ? 'collapsed' : ''}`}>
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{ color: '#ffffff', fontSize: '1.5em', fontWeight: '700' }}>
            Elipse 360°
          </h2>
          <p style={{ color: '#64748b', fontSize: '0.9em', marginTop: '4px' }}>
            Evaluación de Desempeño
          </p>
        </div>

        <nav>
          {navItems.map((item) => (
            <div 
              key={item.id}
              className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item)}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                margin: '4px 0',
                borderRadius: '8px',
                cursor: 'pointer',
                color: activeNav === item.id ? '#3b82f6' : '#94a3b8',
                backgroundColor: activeNav === item.id ? '#1e293b' : 'transparent',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (activeNav !== item.id) {
                  e.target.style.backgroundColor = '#1e293b';
                  e.target.style.color = '#cbd5e1';
                }
              }}
              onMouseLeave={(e) => {
                if (activeNav !== item.id) {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#94a3b8';
                }
              }}
            >
              <span style={{ marginRight: '12px', fontSize: '1.1em' }}>
                {item.icon}
              </span>
              <span style={{ fontSize: '0.95em', fontWeight: '500' }}>
                {item.label}
              </span>
            </div>
          ))}
        </nav>

        {/* User Profile and Logout */}
        <div style={{ 
          marginTop: 'auto', 
          paddingTop: '24px', 
          borderTop: '1px solid #1e293b' 
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px',
            backgroundColor: '#1e293b',
            borderRadius: '8px',
            marginBottom: '12px'
          }}>
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              backgroundColor: '#3b82f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#ffffff',
              fontWeight: '600',
              marginRight: '12px'
            }}>
              {userName.charAt(0).toUpperCase()}
            </div>
            <div>
              <div style={{ color: '#f8fafc', fontSize: '0.9em', fontWeight: '500' }}>
                {userName}
              </div>
              <div style={{ color: '#64748b', fontSize: '0.8em' }}>
                {userRole}
              </div>
            </div>
          </div>
          
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#ef4444',
              color: '#ffffff',
              border: 'none',
              borderRadius: '6px',
              fontSize: '0.9em',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#dc2626'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#ef4444'}
          >
            🚪 Cerrar Sesión
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <div className="header">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '1.2em',
                cursor: 'pointer',
                marginRight: '16px',
                color: '#64748b'
              }}
            >
              ☰
            </button>
            <h1 style={{ 
              fontSize: '1.5em', 
              fontWeight: '600', 
              color: '#ffffff',
              margin: 0
            }}>
              {title}
            </h1>
          </div>
          
          <div style={{ color: '#64748b', fontSize: '0.9em' }}>
            {new Date().toLocaleDateString('es-ES', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </div>
        </div>

        {/* Content Area */}
        <div className="content-area">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardBase;
